import styled, { css } from 'styled-components';

import type { BoxProps } from '@/components/Box';
import { Box } from '@/components/Box';

export const LogoBox = styled(Box)<
  BoxProps & {
    $disableClick?: boolean | null;
  }
>`
  display: inline-block;
  position: relative;
  img {
    pointer-events: none; //prevent Edge show visual search icon
  }
  ${({ $disableClick }) =>
    css`
      cursor: ${$disableClick ? 'default' : 'pointer'};
    `}
`;
export const Wrapper = styled(Box)<BoxProps>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  ${({
    theme: {
      components: { header },
    },
  }) => css`
    @media (max-width: ${header.breakpoint}) {
      display: none;
    }
  `}
`;

export const WrapperInline = styled(Wrapper)`
  display: flex;

  ${({
    theme: {
      components: { header },
    },
  }) =>
    css`
      display: none;
      @media (max-width: ${header.breakpoint}) {
        display: flex;
      }
    `}
`;
